import APIRequest from "./APIRequest";

// Admin API Keys Management Services
export const getApiKeys = (params) => {
  return APIRequest.get(`admin/apikey/list`, params);
};

export const getApiKeyById = (apiKeyId) => {
  return APIRequest.get(`admin/apikey/${apiKeyId}`);
};

export const createApiKey = (apiKeyData) => {
  return APIRequest.post(`/admin/create-apikey`, apiKeyData);
};

export const updateApiKey = ({ apiKeyId, apiKeyData }) => {
  return APIRequest.put(`admin/apikey/${apiKeyId}`, apiKeyData);
};

export const deleteApiKey = (apiKeyId) => {
  return APIRequest.delete(`admin/apikey/${apiKeyId}`);
};

export const toggleApiKeyStatus = (apiKeyId) => {
  return APIRequest.post(`admin/apikey/${apiKeyId}/toggle-status`);
};

export const getApiKeyUsage = ({ apiKeyId, filters = {} }) => {
  return APIRequest.get(`admin/apikey/${apiKeyId}/usage`, { params: filters });
};

export const revokeApiKey = (apiKeyId) => {
  return APIRequest.post(`admin/apikey/${apiKeyId}/revoke`);
};

export const getApiUsageStats = (filters = {}) => {
  return APIRequest.get(`admin/apikey/usage-stats`, { params: filters });
};

export const bulkUpdateApiKeys = ({ apiKeyIds, updates }) => {
  return APIRequest.post(`admin/apikey/bulk-update`, { apiKeyIds, updates });
};

export const bulkDeleteApiKeys = (apiKeyIds) => {
  return APIRequest.post(`admin/apikey/bulk-delete`, { apiKeyIds });
};

export const exportApiKeys = (filters = {}) => {
  return APIRequest.get(`admin/apikey/export`, { params: filters, responseType: 'blob' });
};
